const config = {
  URL: "https://endpoint.purpletv.app",
  // ACTIVATE_DEVICE: "https://login.purpletv.app/api/verifyDeviceCode",
  IP_ADDRESS: "https://checkip.justwatch.com/",
};

export default config;
